import { render } from "./HowItWorks.vue?vue&type=template&id=4ce7c2fa&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=4ce7c2fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce7c2fa"]])

export default __exports__